import React, { useEffect, useState } from "react"
import Header from "../social-supermarket/components/header/Header"
import { lockScroll } from "../social-supermarket/util/generalUtil"
import BasketSidebar from "../social-supermarket/components/basket/BasketSidebar"
import FooterWrapper from "../social-supermarket/components/footer/FooterWrapper"

const Layout = props => {
  const { children, fullWidth, disableHeadroom, fadeParameters } = props
  const [showButton, setShowButton] = useState(false)

  const containerStyle = fullWidth
    ? {}
    : {
        margin: `0 auto`,
        maxWidth: 1200,
        marginBottom: 20,
      }

  useEffect(() => {
    lockScroll(false)
  }, [])

  const unregisterScrollTrigger = () => {
    window.onscroll = null
  }

  const registerScrollTrigger = () => {
    window.onscroll = () => {
      const nextShowButtonValue = document?.documentElement?.scrollTop > 0
      setShowButton(nextShowButtonValue)
    }
  }

  useEffect(() => {
    registerScrollTrigger()
    return () => unregisterScrollTrigger()
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  }

  return (
    <div>
      <BasketSidebar />
      <div>
        <Header siteTitle="Social Supermarket" disableHeadroom={disableHeadroom} />
        <div style={containerStyle} className="ss-body-container">
          <main>{children}</main>
        </div>
        <FooterWrapper />
      </div>
      <div id="modal-root" />
    </div>
  )
}

export default Layout
